import { images } from "../../assets/images";
export const points = [
    {
      heading: "Crafting dreams with a creative approach",
      description:
        "Our commitment is to craft dreams into reality, infusing each endeavor with a unique and imaginative touch.",
    },
    {
      heading: "Transformative journeys for a timeless experience",
      description:
        "Our commitment is to craft dreams into reality, infusing each endeavor with a unique and imaginative touch.",
    },
    {
      heading: "Unleashing innovation, nurturing excellence",
      description:
        "Our commitment is to craft dreams into reality, infusing each endeavor with a unique and imaginative touch.",
    },
  ];

 export const employeeImg = [
    {
      img: images.frame17,
      name: "Rahul kumar",
      designation: "Designation@Avasify",
    },
    {
      img: images.frame18,
      name: "Saniya Sharma",
      designation: "Designation@Avasify",
    },
    {
      img: images.frame19,
      name: "Tanvi Tripathi",
      designation: "Designation@Avasify",
    },
    {
      img: images.frame20,
      name: "Ajay Prasad",
      designation: "Designation@Avasify",
    },
  ];

 export const jobOpening = [
    {
      jobName: "Engineering manager",
      jobLocation: "Remote, Home",
      postDay: "Posted 3 days ago",
      jobVaccancy: "1 seat available",
      jobDescription:
        "We’re looking for an experienced engineering manager to join our team.",
      jobType: "Full-time position",
      salary: "90k-120k",
      sector: "Technology",
    },
    {
      jobName: "Front-end developer",
      jobLocation: "On-site, Pune",
      postDay: "Posted 3 days ago",
      jobVaccancy: "1 seat available",
      jobDescription:
        "We’re looking for an experienced engineering manager to join our team.",
      jobType: "Full-time position",
      salary: "90k-120k",
      sector: "Technology",
    },
    {
      jobName: "Back-end developer",
      jobLocation: "Remote, Home",
      postDay: "Posted 3 days ago",
      jobVaccancy: "1 seat available",
      jobDescription:
        "We’re looking for an experienced engineering manager to join our team.",
      jobType: "Full-time position",
      salary: "90k-120k",
      sector: "Technology",
    },
    {
      jobName: "Quality assuarance",
      jobLocation: "On-site, Pune",
      postDay: "Posted 3 days ago",
      jobVaccancy: "1 seat available",
      jobDescription:
        "We’re looking for an experienced engineering manager to join our team.",
      jobType: "Full-time position",
      salary: "90k-120k",
      sector: "Finance",
    },
    {
      jobName: "Associate product manager",
      jobLocation: "Remote, Home",
      postDay: "Posted 3 days ago",
      jobVaccancy: "1 seat available",
      jobDescription:
        "We’re looking for an experienced engineering manager to join our team.",
      jobType: "Full-time position",
      salary: "90k-120k",
      sector: "Finance",
    },
    {
      jobName: "Ui/Ux Designer",
      jobLocation: "Remote, Home",
      postDay: "Posted 3 days ago",
      jobVaccancy: "1 seat available",
      jobDescription:
        "We’re looking for an experienced engineering manager to join our team.",
      jobType: "Full-time position",
      salary: "90k-120k",
      sector: "Design",
    },
    {
      jobName: "Senior Devepoler",
      jobLocation: "On-site, Pune",
      postDay: "Posted 3 days ago",
      jobVaccancy: "1 seat available",
      jobDescription:
        "We’re looking for an experienced engineering manager to join our team.",
      jobType: "Full-time position",
      salary: "90k-120k",
      sector: "Technology",
    },
    {
      jobName: "Senior Devops",
      jobLocation: "Remote, Home",
      postDay: "Posted 3 days ago",
      jobVaccancy: "1 seat available",
      jobDescription:
        "We’re looking for an experienced engineering manager to join our team.",
      jobType: "Full-time position",
      salary: "90k-120k",
      sector: "Technology",
    },
    {
      jobName: "Customer Support",
      jobLocation: "Remote, Home",
      postDay: "Posted 3 days ago",
      jobVaccancy: "1 seat available",
      jobDescription:
        "We’re looking for an experienced engineering manager to join our team.",
      jobType: "Full-time position",
      salary: "90k-120k",
      sector: "Technology",
    },
  ];
